export const getWebPagesId = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  const subdomain = parts.length >= 3 ? parts[0] : null;

  const subdomainMap = {
    kpk: 4,
    zkpsh: 5,
    pa: 6,
    ps: 27,
    pthprishtine: 28,
    pthprizren: 31,
    pthferizaj: 32,
    pthpeje: 30,
    pthmitrovice: 29,
    pthgjilan: 33,
    pthgjakove: 34,
    sekretariati: 1191,
    "app-prokuroria": 3,
  };

  const defaultId = 3;

  if (subdomain && subdomainMap[subdomain]) {
    return subdomainMap[subdomain];
  }

  if (hostname === "prokuroria-rks.org" || !subdomain) {
    return defaultId; // 3 për domainin bazë
  }

  return defaultId;
};
